<script lang="ts">
  export let onBack = () => {
  };
  export let title = "";
</script>

<div class="container">
  <div class="wrapper">
    <svg
      fill="currentColor"
      on:click={onBack}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
        fill-rule="evenodd"
      />
    </svg>
    <h1>{title}</h1>
  </div>
</div>

<style lang="scss">
  .container {
    background: white;
    position: sticky;
    top: 0;
    padding: 15px;
    border-bottom: 1px solid #e0e0e0;
  }

  .wrapper {
    display: flex;
    align-items: center;

    h1 {
      margin-bottom: 0;
    }

    svg {
      height: 24px;
      width: 24px;
      margin-right: 15px;
    }
  }
</style>
